import classNames from '@/utils/helpers/class-names.helper'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

const useScrollXPagination = (sliderRefProp?: React.RefObject<HTMLUListElement>) => {
  const sliderRef = useRef<HTMLUListElement>(null)
  const [activeIndex, setActiveIndex] = useState(0)
  const [showDots, setShowDots] = useState(false)
  const [itemsLength, setItemsLength] = useState(0)

  const handleScroll = useCallback(() => {
    const slider = sliderRefProp?.current || sliderRef.current
    if (!slider) return
    const scrollLeft = slider.scrollLeft
    const width = slider.clientWidth
    const index = Math.round(scrollLeft / width)
    setItemsLength(slider.childNodes.length)
    setActiveIndex(index)
  }, [sliderRefProp])

  const checkOverflow = useCallback(() => {
    const slider = sliderRefProp?.current || sliderRef.current
    if (!slider) return
    setItemsLength(slider.childNodes.length)
    setShowDots(slider.scrollWidth > slider.clientWidth)
  }, [sliderRefProp])

  useEffect(() => {
    const slider = sliderRefProp?.current || sliderRef.current
    if (!slider) return
    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    slider.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('resize', checkOverflow)
      slider.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const pagination = useMemo(
    () =>
      showDots ? (
        <ul className="scroll-x-pagination">
          {Array.from({ length: itemsLength }).map((_, index) => (
            <li key={`slider-dot-${index}`}>
              <button
                disabled
                className={classNames(
                  'scroll-x-pagination__page',
                  index === activeIndex && '_active',
                  (index === activeIndex - 1 || index === activeIndex + 1) && '_near_active'
                )}
              />
            </li>
          ))}
        </ul>
      ) : (
        <></>
      ),
    [showDots, itemsLength, activeIndex]
  )

  return {
    sliderRef,
    pagination,
  }
}

export default useScrollXPagination
